import React, { useContext } from "react";
import Select from "../../Components/Select";
import TenantContext from "../../OnlineFormContext";
import VMRSCodes from "./VMRSCodes";

function Assembly({ selected, system, onChange, equipmentType, equipmentTypeId, hasError }) {
  const contextValues = useContext(TenantContext);
  const vmrsCodes = new VMRSCodes(contextValues.tenantAuthToken, equipmentType, equipmentTypeId);

  return (
    <div className="ui fluid input bs-field system-section">
      <Select
        asynchronous={true}
        paginate={true}
        value={selected}
        loadOptions={async (search, _, { page }) => ({
          ...(await vmrsCodes.assemblyOptions(system, search, page)),
          additional: {
            page: page + 1,
          },
        })}
        onChange={({
          label,
          value,
          system,
          tireCategory,
          equipmentCategoryId,
        }) => {
          onChange({
            option: { label, value },
            system,
            tireCategory,
            equipmentCategoryId,
          });
        }}
        additional={{
          page: 1,
        }}
        hasError={hasError}
        cacheUniq={[selected]}
        placeholder={"Assembly"}
      />
    </div>
  );
}

export default Assembly;
